'use client';

import React, { createContext, useContext } from 'react';
import { StaticBannerBlok } from 'components/storyblok/types';

export interface CategoryPageContent {
  /** The optional banner above every category page, from Storyblok. */
  banner?: StaticBannerBlok;
}

const CategoryPageContentContext = createContext<CategoryPageContent>({});

/**
 * Carries the Storyblok content the route loaded for a category page down to
 * the product-list tastic, which the Studio renderer mounts without a way to
 * pass it extra props.
 */
export const CategoryPageContentProvider = ({
  value,
  children,
}: React.PropsWithChildren<{ value: CategoryPageContent }>) => (
  <CategoryPageContentContext.Provider value={value}>
    {children}
  </CategoryPageContentContext.Provider>
);

export const useCategoryPageContent = () =>
  useContext(CategoryPageContentContext);
